import React from 'react';
import BaseLayout from './BaseLayout';

const PublicLayout: React.FC = () => {
  return <BaseLayout showMenu />;
};

export default PublicLayout;
